import { TWO_FACTOR } from "../../constants/action-types";

const initialState = {
  // Data
  enrolledMethods: [],
  
  // QR Code data for authenticator app
  qrCodeUrl: null,
  secretKey: null,
  
  // Loading states
  loading: false,
  enrolling: false,
  
  // Error handling
  error: null,
  
  // UI state
  isModalOpen: false,
  modalType: null, // 'email', 'sms', 'authapp'
  enrollmentStep: 1,
  
  // Verification state
  verificationCodeSent: false,
  verificationMethod: null,
  verificationPhoneNumber: null,
  
  // Success states
  enrollmentSuccess: false,
  unenrollmentSuccess: false
};

const TwoFactorAuth = (state = initialState, action) => {
  switch (action.type) {
    
    // Enrolled methods
    case TWO_FACTOR.SET_ENROLLED_METHODS: {
      return {
        ...state,
        enrolledMethods: action.payload,
        error: null
      };
    }
    
    // Loading states
    case TWO_FACTOR.SET_LOADING: {
      return {
        ...state,
        loading: action.payload
      };
    }
    
    // Email enrollment
    case TWO_FACTOR.ENROLL_EMAIL_START: {
      return {
        ...state,
        enrolling: true,
        error: null,
        enrollmentSuccess: false
      };
    }
    
    case TWO_FACTOR.ENROLL_EMAIL_SUCCESS: {
      return {
        ...state,
        enrolling: false,
        enrollmentSuccess: true,
        error: null
      };
    }
    
    case TWO_FACTOR.ENROLL_EMAIL_FAILURE: {
      return {
        ...state,
        enrolling: false,
        error: action.payload,
        enrollmentSuccess: false
      };
    }

    case TWO_FACTOR.DISABLE_TWO_FACTOR: {
      return {
        ...state,
        loading: false,
        enrolledMethods: [], 
        error: null,
        unenrollmentSuccess: true,
        qrCodeUrl: null,
        secretKey: null
      };
    }
    
    // SMS enrollment
    case TWO_FACTOR.ENROLL_SMS_START: {
      return {
        ...state,
        enrolling: true,
        error: null,
        enrollmentSuccess: false
      };
    }
    
    case TWO_FACTOR.ENROLL_SMS_SUCCESS: {
      return {
        ...state,
        enrolling: false,
        enrollmentSuccess: true,
        error: null
      };
    }
    
    case TWO_FACTOR.ENROLL_SMS_FAILURE: {
      return {
        ...state,
        enrolling: false,
        error: action.payload,
        enrollmentSuccess: false
      };
    }
    
    // Authenticator App enrollment
    case TWO_FACTOR.ENROLL_AUTH_APP_START: {
      return {
        ...state,
        enrolling: true,
        error: null,
        enrollmentSuccess: false,
        qrCodeUrl: null,
        secretKey: null
      };
    }
    
    case TWO_FACTOR.GENERATE_QR_CODE: {
      return {
        ...state,
        enrolling: false, 
        qrCodeUrl: action.payload.qrCodeUrl,
        secretKey: action.payload.secretKey,
        error: null
      };
    }
    
    case TWO_FACTOR.ENROLL_AUTH_APP_SUCCESS: {
      return {
        ...state,
        enrolling: false,
        enrollmentSuccess: true,
        error: null,
        qrCodeUrl: null,
        secretKey: null
      };
    }
    
    case TWO_FACTOR.ENROLL_AUTH_APP_FAILURE: {
      return {
        ...state,
        enrolling: false,
        error: action.payload,
        enrollmentSuccess: false,
        qrCodeUrl: null,
        secretKey: null
      };
    }
    
    // Unenrollment
    case TWO_FACTOR.UNENROLL_METHOD_START: {
      return {
        ...state,
        loading: true,
        error: null,
        unenrollmentSuccess: false
      };
    }
    
    case TWO_FACTOR.UNENROLL_METHOD_SUCCESS: {
      return {
        ...state,
        loading: false,
        unenrollmentSuccess: true,
        error: null
      };
    }
    
    case TWO_FACTOR.UNENROLL_METHOD_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
        unenrollmentSuccess: false
      };
    }
    
    // Verification code
    case TWO_FACTOR.SEND_VERIFICATION_CODE: {
      return {
        ...state,
        verificationCodeSent: true,
        verificationMethod: action.payload.method,
        verificationPhoneNumber: action.payload.phoneNumber || null,
        error: null
      };
    }
    
    case TWO_FACTOR.VERIFY_CODE_SUCCESS: {
      return {
        ...state,
        verificationCodeSent: false,
        verificationMethod: null,
        verificationPhoneNumber: null,
        enrollmentSuccess: true,
        error: null
      };
    }
    
    case TWO_FACTOR.VERIFY_CODE_FAILURE: {
      return {
        ...state,
        error: action.payload
      };
    }
    
    // UI state
    case TWO_FACTOR.SET_MODAL_OPEN: {
      return {
        ...state,
        isModalOpen: action.payload,
        // Reset states when modal closes
        ...(action.payload === false && {
          modalType: null,
          enrollmentStep: 1,
          error: null,
          verificationCodeSent: false,
          verificationMethod: null,
          verificationPhoneNumber: null,
          qrCodeUrl: null,
          secretKey: null,
          enrollmentSuccess: false,
          unenrollmentSuccess: false,
          enrolling: false,
          loading: false 
        })
      };
    }
    
    case TWO_FACTOR.SET_MODAL_TYPE: {
      return {
        ...state,
        modalType: action.payload,
        // Reset enrollment state when switching modal type
        enrollmentStep: 1,
        error: null,
        verificationCodeSent: false,
        verificationMethod: null,
        verificationPhoneNumber: null,
        qrCodeUrl: null,
        secretKey: null
      };
    }
    
    case TWO_FACTOR.SET_ENROLLMENT_STEP: {
      return {
        ...state,
        enrollmentStep: action.payload
      };
    }
    
    // Error handling
    case TWO_FACTOR.SET_ERROR: {
      return {
        ...state,
        error: action.payload
      };
    }
    
    case TWO_FACTOR.CLEAR_ERROR: {
      return {
        ...state,
        error: null
      };
    }
    
    default:
      return state;
  }
};

export default TwoFactorAuth;